export enum ReportStatus {
  Draft = 1,
  Favorite = 2,
  Suggested = 3,
  Shared = 4,
  Temp = 5,
}
